<template>
  <v-container fluid v-scroll="onScroll" id="topo">
    <z-loading :loading="loading" height="300px">
      <div class="mb-3">
        <v-btn
          color="primary"
          text
          @click="$router.push({ name: 'ProdutosLista' })"
        >
          <v-icon left>mdi-arrow-left</v-icon>
          Voltar
        </v-btn>
      </div>

      <v-card outlined class="mb-5">
        <v-list-item three-line>
          <v-list-item-content>
            <div class="overline">Histórico do Produto</div>
            <v-list-item-title class="headline mb-1"
              >{{ produto.referencia }} -
              {{ produto.descricao }}</v-list-item-title
            >
            <v-list-item-subtitle
              >Estoque atual: {{ produto.estoque }}</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
      </v-card>

      <v-card tile outlined>
        <v-tabs v-model="tab" color="primary">
          <v-tab>Histórico</v-tab>
          <v-tab>Gráficos</v-tab>
          <v-tabs-slider color="primary"></v-tabs-slider>
        </v-tabs>

        <!-- <v-divider></v-divider> -->

        <v-tabs-items v-model="tab" touchless>
          <v-tab-item>
            <v-toolbar color="white" dense flat>
              <span class="mr-5">Movimentação a partir de:</span>
              <z-date-navigation
                color="grey lighten-2"
                v-model="data"
                sem-setas
                @input="dataChange"
              ></z-date-navigation>
            </v-toolbar>
            <!-- <v-divider></v-divider> -->
            <v-container fluid>
              <v-data-table
                :headers="headers"
                :items="items"
                disable-pagination
                disable-sort
                hide-default-footer
                :loading="loadingHistorico"
                loading-text="Carregando histórico..."
                dense
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td>{{ item.created_at }}</td>
                    <td>{{ item.evento_texto }}</td>
                    <td class="text-right">
                      <span
                        v-if="
                          item.evento == 'Saída' ||
                            item.evento == 'Venda' ||
                            item.quantidade < 0
                        "
                        style="color: red"
                        >{{ item.quantidade | valorBR(0) }}</span
                      >
                      <span v-else>{{ item.quantidade | valorBR(0) }}</span>
                    </td>
                    <td class="text-right">{{ item.saldo | valorBR(0) }}</td>
                    <td class="text-right">{{ item.valor | valorBR }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container fluid>
              <h1>Gráficos</h1>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </z-loading>

    <div id="final"></div>

    <v-fab-transition>
      <v-btn
        color="primary"
        dark
        right
        bottom
        fab
        fixed
        v-show="showFab"
        @click="$vuetify.goTo('#topo', { duration: 300, offset: 30 })"
      >
        <v-icon>mdi-arrow-up</v-icon>
      </v-btn>
    </v-fab-transition>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ProdutosHistorico",
  data() {
    return {
      tab: 0,
      loading: false,
      loadingHistorico: false,

      headers: [
        { text: "Data", value: "created_at", width: "200px" },
        { text: "Evento", value: "evento" },
        { text: "Quantidade", value: "quantidade", align: "right" },
        { text: "Saldo", value: "saldo", align: "right" },
        { text: "Valor", value: "valor", align: "right" },
      ],
      items: [],
      titulo: "Histórico de Movimentação",
      // data: (new Date).toISOString().substring(0,10)
      data: new Date().toISOString().substring(0, 10),
      offsetTop: 0,
    };
  },

  async mounted() {
    if (this.$route.params.id) {
      await this.abrirProduto(this.$route.params.id);
      this.setData();
      this.historico(this.$route.params.id, this.data);
    }
  },

  methods: {
    async abrirProduto(produto_id) {
      try {
        this.loading = true;
        await this.$store.dispatch("produtos/abrir", produto_id);
      } catch (error) {
        this.$eventbus.erroSistema("Não foi possível abrir o produto");
      } finally {
        this.loading = false;
      }
    },

    setData() {
      let data = new Date();
      data.setDate(data.getDate() - 30);
      this.data = data.toISOString().substring(0, 10);
    },

    async historico(produto_id, data) {
      if (!produto_id) {
        return false;
      }

      this.items = [];

      try {
        this.loadingHistorico = true;
        let historico = await this.$axios
          .get("/produtos/" + produto_id + "/historico?data=" + data)
          .then((response) => response.data);
        this.items = historico;

        setTimeout(() => {
          this.$vuetify.goTo("#final", { duration: 300, offset: 30 });
        }, 500);
      } catch (error) {
        this.$eventbus.erroSistema(
          "Não foi possível carregar o histórico do produto"
        );
      } finally {
        this.loadingHistorico = false;
      }
    },

    dataChange() {
      this.historico(this.produto.id, this.data);
    },

    onScroll(e) {
      this.offsetTop = window.pageYOffset;
    },
  },

  computed: {
    ...mapState("produtos", ["produto"]),

    showFab() {
      return this.offsetTop >= 50;
    },
  },
};
</script>

<style scoped></style>
